import { createContext } from 'react';
import { type Faro } from '@grafana/faro-web-sdk';

export type TelemetryContextState = {
  instance: Faro;
  setUser: (id: string, mail: string) => void;
};

const TelemetryContext = createContext<TelemetryContextState | undefined>(
  undefined
);

export default TelemetryContext;
